/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterD = createReactComponent("outline", "letter-d", "IconLetterD", [["path", { "d": "M7 4h6a5 5 0 0 1 5 5v6a5 5 0 0 1 -5 5h-6v-16", "key": "svg-0" }]]);

export { IconLetterD as default };
//# sourceMappingURL=IconLetterD.mjs.map
